import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef } from "react";
import { TURNSTILE_SITE_KEY } from "@globalConfig";
var SCRIPT_ID = "turnstile-api-js";
var SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

// Loads turnstile api.js once, resolves when window.turnstile is ready.
var loadTurnstile = function loadTurnstile() {
  return new Promise(function (resolve, reject) {
    var w = window;
    if (w.turnstile && w.turnstile.render) {
      resolve(w.turnstile);
      return;
    }
    var script = document.getElementById(SCRIPT_ID);
    var onReady = function onReady() {
      if (w.turnstile && w.turnstile.render) resolve(w.turnstile);else reject(new Error("turnstile unavailable"));
    };
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      script.onerror = function () {
        return reject(new Error("turnstile script failed"));
      };
      document.head.appendChild(script);
    }
    // api.js doesn't fire a load event reliably for explicit mode; poll.
    var start = Date.now();
    var timer = setInterval(function () {
      if (w.turnstile && w.turnstile.render) {
        clearInterval(timer);
        onReady();
      } else if (Date.now() - start > 10000) {
        clearInterval(timer);
        reject(new Error("turnstile load timeout"));
      }
    }, 200);
  });
};
var ReCaptcha = function ReCaptcha(_ref) {
  var onChange = _ref.onChange,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "ar" : _ref$lang;
  var containerRef = useRef(null);
  var widgetIdRef = useRef(null);
  useEffect(function () {
    if (!__IS_CSR__) return;
    var cancelled = false;
    loadTurnstile().then(function (turnstile) {
      if (cancelled || !containerRef.current) return;
      if (widgetIdRef.current !== null) return; // already rendered
      widgetIdRef.current = turnstile.render(containerRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        language: lang,
        callback: function callback(token) {
          return onChange(token);
        },
        "expired-callback": function expiredCallback() {
          return onChange(null);
        },
        "error-callback": function errorCallback() {
          return onChange(null);
        }
      });
    })["catch"](function () {
      return onChange(null);
    });
    return function () {
      cancelled = true;
      var w = window;
      if (widgetIdRef.current !== null && w.turnstile) {
        w.turnstile.remove(widgetIdRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  });
};
export default ReCaptcha;